import create from "zustand";

export const useSidebarStore = create((set) => ({
  isSidebarOpen: false,
  setIsSidebarOpen: (newSidebarState) => set((state) => ({ isSidebarOpen: newSidebarState })),

  selectedSidebarType: undefined,
  setSelectedSidebarType: (sidebarType) => set((state) => ({ selectedSidebarType: sidebarType })),

  reset: () => set((state) => ({ isSidebarOpen: false, selectedSidebarType: undefined })),
}));
